module.exports = __webpack_public_path__ + "img/compass-icon.5129c8ab.svg";